// @flow
import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';

import * as paths from 'constants/paths.js';
import { SessionConsumer } from 'session';

type Props = {|
  children?: any => React.Node,
  component: any => React.Node,
  path?: string,
  exact?: boolean,
|};

const AuthenticatedRoute = ({ children, component, path, exact }: Props) => {
  const ChildComponent = children || component;

  return (
    <SessionConsumer>
      {({ session, loading }) =>
        !loading && (
          <Route
            path={path}
            exact={exact}
            render={props =>
              session ? (
                <ChildComponent {...props} />
              ) : (
                <Redirect
                  to={{
                    pathname: paths.LOGIN,
                    state: { from: props.location },
                  }}
                />
              )
            }
          />
        )
      }
    </SessionConsumer>
  );
};
export default AuthenticatedRoute;
